import CheckPoint from "@pages/ListMangement/CheckPoint";
import ChoiceList from "@pages/ListMangement/ChoiceList";
import Country from "@pages/ListMangement/Country";

export const ListManagementRoutes = [
  {
    path: "/list-management/country",
    // name: "ListManagement",
    name: "configuration_list_management_choice_list",
    component: Country,
  },
  {
    path: "/configuration/list-management/choice-list",
    name: "configuration_list_management_choice_list",
    component: ChoiceList,
  },
  {
    path: "/configuration/list-management/checkPoint",
    name: "configuration_list_management_checkpoint",
    component: CheckPoint,
  },
];
